import { render } from "./PopUser.vue?vue&type=template&id=04f8da64"
import script from "./PopUser.vue?vue&type=script&lang=js"
export * from "./PopUser.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__